<irembogov-select
  [loading]="loading"
  [customFormControl]="formControl"
  [items]="items"
  [bindLabel]="field.props['bindLabel']"
  ngDefaultControl
  [bindValue]="field.props['bindValue']"
  [placeholder]="field.props.placeholder ? field.props.placeholder : ''"
  [labelForId]="field.key"
  [multiple]="field.props['multiple']"
  [max]="field.props['max']"
  [min]="field.props['min']"></irembogov-select>

<div *ngIf="isConditionalActionVisible" class="mt-3">
  <label class="form-label" [for]="conditionalActionInputId">
    {{ conditionalActionConfig?.input?.label ?? '' | translate }}
  </label>
  <div class="row g-2 align-items-start">
    <div class="col-12 col-md-8">
      <input
        class="form-control"
        [class.is-invalid]="
          conditionalActionInput.touched && conditionalActionInput.invalid
        "
        [id]="conditionalActionInputId"
        type="text"
        [formControl]="conditionalActionInput"
        [readOnly]="isConditionalActionDisabled || conditionalActionProcessing"
        [attr.maxlength]="conditionalActionConfig?.input?.maxLength"
        [placeholder]="
          conditionalActionConfig?.input?.placeholder ?? '' | translate
        " />
      <div
        *ngIf="conditionalActionInput.touched && conditionalActionInput.invalid"
        class="invalid-feedback d-block">
        {{ conditionalActionConfig?.input?.requiredMessage ?? '' | translate }}
      </div>
    </div>
    <div class="col-12 col-md-4">
      <irembogov-generic-button
        [id]="conditionalActionInputId + '-button'"
        [buttonText]="conditionalActionConfig?.buttonText ?? ''"
        [statusClass]="conditionalActionStatus"
        [disabled]="isConditionalActionButtonDisabled"
        (buttonClick)="onConditionalActionClick()">
      </irembogov-generic-button>
    </div>
  </div>
  <div *ngIf="conditionalActionError" class="text-danger mt-2" role="alert">
    {{ conditionalActionError | translate }}
  </div>
</div>
